module.exports = __webpack_public_path__ + "img/palmar-room-7.f5858ba4.jpg";